import { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom"
import './Search.css'
import { RoutingPath } from '../../routes/RoutingPath'

function Search(props) {
    const [value, setValue] = useState("") // double value becouse of updateing search on makeASearch
    const [error, setError] = useState(false)
    const [hoverSearch, setHoverSearch] = useState(false)
    const [hoverBack, setHoverBack] = useState(false)
    let history = useHistory();

    const makeASearch = (event) => {
        if (value.length < 2) {
            setError(true)
        } else {
            setError(false)
            event.preventDefault()
            props.setShowSearch(false)
            props.setSearchValue(value)
            history.push(RoutingPath.search)
        }
    }

    const closeSearch = () => {
        props.setShowSearch(false)
    }

    // auto focus in search field
    useEffect(() => {
        document.getElementById("searchbox").focus()
    }, [])

    // auto search on enter click
    const handleKeyPress = (event) => {
        if (event.charCode === 13) {
            makeASearch(event)
        }
    }

    return (
        <>
            <div className="searchform">
                <div>
                    <input
                        type="text"
                        id="searchbox"
                        placeholder="Sök..."
                        onChange={(event) => setValue(event.target.value)}
                        onKeyPress={handleKeyPress}
                    />
                </div>
                <div>
                    <img 
                        src={hoverSearch ? "/img/search-hover.png" : "/img/search.png"}
                        onMouseOver={() => setHoverSearch(true)}
                        onMouseOut={() => setHoverSearch(false)}  
                        onClick={makeASearch}
                        alt="Sök"
                    />
                </div>
                <div>
                    <img
                        src={hoverBack ? "/img/back-hover.png" : "/img/back.png"}
                        onMouseOver={() => setHoverBack(true)}
                        onMouseOut={() => setHoverBack(false)}
                        onClick={closeSearch}
                        alt="Tillbaka"
                    />
                </div>
            </div>
            {error ? <div className="error">Du måste skriva minst två tecken.</div> : null}
        </>
    )
}

export default Search